// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overview-chart[data-v-011333fe] {\n  padding: 0;\n}\n.badge[data-v-011333fe] {\n  margin-right: 0.4rem;\n}\n", ""]);
// Exports
module.exports = exports;
